import axios from "axios";
import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
    const [currentuser, setCurrentuser] = useState(JSON.parse(localStorage.getItem('user') || null));
    // const [newRequest, setNewRequest] = useState(null);
    // const [pendingRequest, setPendingRequest] = useState(null);
    const [request, setRequest] = useState(null);
    const [err, setError] = useState("");

    const base_url = "https://ethioinstallglobaltrade.com";
    // const base_url = "http://192.168.1.7:3001";
    // const base_url = "http://192.168.245.125:3001";
    // const base_url = "http://172.22.158.122:3001";
    // const base_url = "https://www.ethioglobal.org";

    useEffect(() => {
        localStorage.setItem('user', JSON.stringify(currentuser));
    }, [currentuser]);
   
    const loginsupplier = async (inputs) => {
        console.log(inputs);
        try {
            const res = await axios.post(base_url + '/auth/loginsupplier', inputs);
            if (!res.data.error) {
                const { token, message, ...user } = res.data;
                setCurrentuser({ ...user, token });
                window.location.href = '/home';
                return null;
            } else {
                return res.data.error;
            }
        } catch (error) {
            setError(error);
            return error;
        }
    };

    const registersupplier = async (inputs) => {
        try {
            const res = await axios.post(base_url + '/auth/ethioglobal/registersupplier', inputs);
            if (!res.data.error) {
                await loginsupplier(inputs);
                // const { token, message, ...user } = res.data;
                // setCurrentuser({ ...user, token })
                // window.location.href = '/home';
                return null;
            } else {
                alert(res.data.error);
                return res.data.error;
            }
        } catch (error) {
            setError(error);
            return error;
        }
    };

    const logincustomer = async (inputs) => {
        try {
            const res = await axios.post(base_url + '/auth/ethioglobal/logincustomer', inputs);
            if (!res.data.error) {
                const { token, message, ...user } = res.data;
                setCurrentuser({ ...user, token });
                window.location.href = '/members/upload';
                return null;
            } else {
                return res.data.error;
            }
        } catch (error) {
            setError(error);
            return error;
        }
    };

    const registercustomer = async (inputs) => {
        console.log(inputs);
        try {
            const res = await axios.post(base_url + '/auth/ethioglobal/registercustomer', inputs);
            if (!res.data.error) {
                console.log(res.data);
                const { token, message, ...user } = res.data;
                setCurrentuser({ ...user, token })
                window.location.href = '/members/upload';
                return null;
            } else {
                alert(res.data.error);
                return res.data.error;
            }
        } catch (error) {
            setError(error);
            return error;
        }
    };

    const loginuser = async (inputs) => {
        try {
            const res = await axios.post(base_url + '/account/loginuser', inputs);
            if (!res.data.error) {
                const { token, message, ...userData } = res.data;
                setCurrentuser({ ...userData, token });
                window.location.href = '/';
                return Promise.resolve(null); // Resolve the promise with null
            } else {
                alert('error response');
                return Promise.resolve(res.data.error); // Resolve with the error
            }
        } catch (error) {
            setError(error);
            return Promise.resolve(error); // Resolve with the caught error
        }
    };

    const logout = async () => {
        console.log('to logout');
        // await axios.post(base_url + '/auth/logout',{username:currentuser.username}).then((res) => {
            setCurrentuser(null);
            window.location.href = '/';
        // });
    }

    return (
        <AuthContext.Provider value={{ currentuser, err, base_url, request, loginuser, loginsupplier, registersupplier, logincustomer, registercustomer, logout, setRequest }}>{children}</AuthContext.Provider>
    )
};